// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LobbyNamesList_wrapper__1ji1Z","item":"LobbyNamesList_item__3Akwi"};